export const subtractMonthsSafe = (base: Date, months: number): Date => {
  const month = base.getMonth();
  const year = base.getFullYear();
  const targetMonth = month - months;
  const targetYear =
    targetMonth >= 0 ? year : year - Math.ceil((1 - (targetMonth + 1)) / 12);
  const normalizedMonth = ((targetMonth % 12) + 12) % 12;
  const day = base.getDate();
  const endOfTargetMonth = new Date(
    targetYear,
    normalizedMonth + 1,
    0
  ).getDate();
  const targetDay = Math.min(day, endOfTargetMonth);
  return new Date(targetYear, normalizedMonth, targetDay);
};
